import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon } from '@livable/saas-react-components';
import { Checkbox, FormControl, FormControlLabel, FormGroup, InputAdornment, InputLabel, OutlinedInput, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import useStyles from '../styles';
export default function FeeType(_ref) {
  let _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$enableSwitcher = _ref.enableSwitcher,
    enableSwitcher = _ref$enableSwitcher === void 0 ? false : _ref$enableSwitcher;
  const classes = useStyles();
  const _useState = useState('$'),
    _useState2 = _slicedToArray(_useState, 2),
    feeCurrency = _useState2[0],
    setFeeCurrency = _useState2[1];
  const handleFeeCurrencyChange = (e, value) => {
    if (value) setFeeCurrency(value);
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    feeActive = _useState4[0],
    setFeeActive = _useState4[1];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.feeRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeType
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      value: feeActive,
      onChange: () => setFeeActive(!feeActive)
    }),
    label: label
  }))), enableSwitcher && /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    onChange: handleFeeCurrencyChange,
    value: feeCurrency,
    disabled: !feeActive,
    className: classes.currencyToggler,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "$"
  }, "$"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "%"
  }, "%")), /*#__PURE__*/React.createElement("div", {
    className: classes.field
  }, !feeActive && /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "input-with-icon",
    label: "Value",
    variant: "outlined",
    disabled: true
  })), feeActive && /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, "Bill value"), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "fee-type",
    label: "Bill value",
    type: "number",
    placeholder: "0.00",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, feeCurrency)
  }))));
}
FeeType.propTypes = {
  label: PropTypes.string,
  enableSwitcher: PropTypes.bool
};